/**
 * @generated SignedSource<<703659f4144d6fde51f5e3785615687e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "teamId",
        "variableName": "teamId"
      },
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "removeUserFromTeam",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveUserFromTeamMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RemoveUserFromTeamMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4eb453b6a022351dd37e90ea7cf36fe3",
    "id": null,
    "metadata": {},
    "name": "RemoveUserFromTeamMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveUserFromTeamMutation(\n  $teamId: ID!\n  $userId: ID!\n) {\n  removeUserFromTeam(teamId: $teamId, userId: $userId) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "e884dea561dfb9d5805d69eb7c995d2e";

export default node;
